<div
    class="d-flex flex-column h-100 counting-main-container"
    [ngClass]="{ 'justify-content-center': shouldCenterContent }"
>
    <div
        class="w-100"
        *ngIf="
            selectedLocalBusiness.groupsCountingEnabled;
            else noGroupCountingData
        "
    >
        <app-counting-data
            [img]="'customers-group-dark'"
            [current]="principalData.current.nbGroups"
            [versus]="principalData.versus.nbGroups"
            [variation]="principalData.comparison.nbGroups"
            [variationUnit]="'%'"
        ></app-counting-data>
    </div>
    <div class="w-100" *ngIf="entriesKeys.length > 1">
        <div
            class="counting-data d-flex align-items-center justify-content-between my-1 row p-0 mx-0"
        >
            <div class="col-2 d-flex center">
                <img
                    src="/assets/svg/entry-passage.svg"
                    height="25px"
                    class="entry-passage"
                />
            </div>

            <div class="col-10 d-flex flex-column">
                <div
                    class="d-flex align-items-center justify-content-between w-100 row entry-row mx-0"
                    *ngFor="
                        let entryName of entriesExpanded
                            ? entriesKeys
                            : (entriesKeys | slice : 0 : 2)
                    "
                >
                    <div
                        class="col-6 d-flex flex-column align-items-start justify-content-center ps-0"
                    >
                        <div class="entry-label">{{ entryName }}</div>
                        <div class="d-flex align-items-baseline gap-2">
                            <div class="m-0 ref-data">
                                {{
                                    principalData.current.entries[entryName]
                                        .nbPerson | numberSuffix : 0
                                }}
                            </div>
                            <div class="comp-data">
                                vs :
                                {{
                                    principalData.versus.entries[entryName]
                                        .nbPerson | numberSuffix : 0
                                }}
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-4 rounded p-1 px-2 center d-flex flex-row variation-neutral"
                        [ngClass]="{
                            'variation-positive':
                                principalData.comparison.entries[entryName]
                                    .nbPerson > 0,
                            'variation-negative':
                                principalData.comparison.entries[entryName]
                                    .nbPerson < 0
                        }"
                    >
                        <div>
                            {{
                                principalData.comparison.entries[entryName]
                                    .nbPerson > 0
                                    ? '+'
                                    : ''
                            }}{{
                                principalData.comparison.entries[entryName]
                                    .nbPerson | numberSuffix : 1
                            }}
                        </div>
                        <div class="ps-1"><small>%</small></div>
                    </div>
                </div>

                <button
                    type="button"
                    class="entries-toggle"
                    *ngIf="entriesKeys.length > 2"
                    (click)="toggleEntries()"
                >
                    {{
                        entriesExpanded
                            ? ('seeLess' | translate)
                            : ('seeMore' | translate) +
                              ' (' +
                              (entriesKeys.length - 2) +
                              ')'
                    }}
                </button>
            </div>
        </div>
    </div>

    <div class="w-100" *ngIf="settings?.attractivity">
        <app-counting-data
            [img]="
                selectedLocalBusiness.attractivityEnabled
                    ? 'localbusiness'
                    : 'localbusiness-warning'
            "
            [current]="
                selectedLocalBusiness.attractivityEnabled
                    ? principalData.current.passages
                    : principalData.current.attractivityWifi
            "
            [versus]="
                selectedLocalBusiness.attractivityEnabled
                    ? principalData.versus.passages
                    : principalData.versus.attractivityWifi
            "
            [variation]="principalData.comparison.passages"
            [variationUnit]="'%'"
        ></app-counting-data>
    </div>

    <div class="w-100" *ngIf="settings?.attractivity">
        <app-counting-data
            [img]="'attractivity-video'"
            [current]="
                selectedLocalBusiness.attractivityEnabled
                    ? principalData.current.attractivenessRate
                    : principalData.current.attractivityWifi
            "
            [versus]="
                selectedLocalBusiness.attractivityEnabled
                    ? principalData.versus.attractivenessRate
                    : principalData.versus.attractivityWifi
            "
            [variation]="
                selectedLocalBusiness.attractivityEnabled
                    ? principalData.comparison.attractivenessRate
                    : principalData.comparison.attractivityWifi
            "
            [unit]="'%'"
            [decimalPosition]="1"
            [variationUnit]="' Pt'"
        ></app-counting-data>
    </div>

    <div
        class="w-100"
        *ngIf="
            selectedLocalBusiness.localBusinessFiancial;
            else noFinancialData
        "
    >
        <app-counting-data
            [img]="'euro'"
            [current]="principalData.current.turnover"
            [versus]="principalData.versus.turnover"
            [variation]="principalData.comparison.turnover"
            [unit]="'€'"
            [variationUnit]="'%'"
        ></app-counting-data>
    </div>

    <div class="w-100" *ngIf="selectedLocalBusiness.localBusinessFiancial">
        <app-counting-data
            [img]="'tickets-by-customers'"
            [current]="principalData.current.transformationRate"
            [versus]="principalData.versus.transformationRate"
            [variation]="principalData.comparison.transformationRate"
            [decimalPosition]="1"
            [unit]="'%'"
            [variationUnit]="' Pt'"
        ></app-counting-data>
    </div>

    <ng-template #noFinancialData>
        <div
            class="indic bg-greyOpacity radius-secondary p-3"
            [class.invisible]="!displayRegisterDataInfo"
        >
            <div class="header">
                <div class="small">
                    <b>{{
                        'navSettings.transformationRateData' | translate
                    }}</b>
                </div>
                <img
                    (click)="deleteInfo()"
                    src="assets/svg/close-dark.svg"
                    alt=""
                    width="15px"
                />
            </div>

            <div
                class="small"
                [innerHTML]="'noFinancialDataInfo' | translate"
            ></div>
        </div>
    </ng-template>

    <ng-template #noGroupCountingData>
        <div
            class="indic bg-greyOpacity radius-secondary p-3"
            [class.invisible]="!displayRegisterDataInfo"
        >
            <div class="header">
                <div class="small">
                    <b>{{ 'navSettings.groupData' | translate }}</b>
                </div>
                <img
                    (click)="deleteInfo()"
                    src="assets/svg/close-dark.svg"
                    alt=""
                    width="15px"
                />
            </div>

            <div class="small" [innerHTML]="'noGroupsData' | translate"></div>
        </div>
    </ng-template>
</div>
